import { useRef } from 'react';
export function useCurrentValueRef(value) {
  var ref = useRef(value);
  ref.current = value;
  return ref;
}